// Our Team slider (Splide) - frontend + editor iframe
jQuery(document).ready(function ($) {
  function initOurTeam(root) {
    const context = root && root.querySelectorAll ? root : document;

    if (typeof Splide === "undefined") {
      setTimeout(() => initOurTeam(root), 100);
      return;
    }

    const sections = context.querySelectorAll(".our-team[data-slider-id]");
    if (!sections.length) return;

    sections.forEach((section) => {
      const sliderId = section.getAttribute("data-slider-id");
      if (!sliderId) return;

      const splideEl =
        section.querySelector(`#${CSS.escape(sliderId)}`) ||
        document.getElementById(sliderId);
      if (!splideEl) return;

      // Destroy existing instance if re-rendered in editor
      if (splideEl.__splideInstance) {
        try {
          splideEl.__splideInstance.destroy(true);
        } catch (e) {}
        splideEl.__splideInstance = null;
      }

      const prevBtn = section.querySelector(".our-team__arrow--prev");
      const nextBtn = section.querySelector(".our-team__arrow--next");

      const splide = new Splide(splideEl, {
        type: "slide",
        /* > 1900px: ~4.5 slides */
        perPage: 4,
        gap: "22px",
        padding: { right: "min(220px, max(96px, 11vw))" },
        pagination: false,
        arrows: false,
        drag: true,
        speed: 600,
        breakpoints: {
          /* ≤ 1900px: keep ~4.5 (tuned padding for this band) */
          1900: {
            perPage: 4,
            gap: "22px",
            padding: { right: "min(210px, max(88px, 10.5vw))" },
          },
          /* ≤ 1500px: ~3.5 slides */
          1500: {
            perPage: 3,
            gap: "22px",
            padding: { right: "min(200px, max(72px, 13vw))" },
          },
          1200: {
            perPage: 3,
            gap: "20px",
            padding: { right: "min(160px, max(56px, 11vw))" },
          },
          992: {
            perPage: 2,
            gap: "18px",
            padding: { right: "min(140px, max(48px, 14vw))" },
          },
          768: {
            /* 501–768px: dvi pilnos skaidrės, be peek */
            perPage: 2,
            gap: "14px",
            padding: { right: "0" },
          },
          /* ≤500px: viena pilna skaidrė */
          500: {
            perPage: 1,
            gap: "16px",
            padding: { right: "0" },
          },
        },
      });

      function updateButtons() {
        if (!prevBtn || !nextBtn) return;
        const len = splide.length;
        if (len <= 1) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }
        const end =
          splide.Components && splide.Components.Controller
            ? splide.Components.Controller.getEnd()
            : len - 1;
        prevBtn.disabled = splide.index <= 0;
        nextBtn.disabled = splide.index >= end;
      }

      splide.on("mounted move updated resized", updateButtons);

      splide.mount();
      splideEl.__splideInstance = splide;

      if (prevBtn) {
        prevBtn.addEventListener("click", () => splide.go("<"));
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", () => splide.go(">"));
      }
    });
  }

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(() => initOurTeam());
  } else {
    initOurTeam();
  }

  // Re-init on ACF preview render (API v3)
  if (typeof acf !== "undefined" && typeof acf.addAction === "function") {
    acf.addAction("render_block_preview/type=our-team", function ($block) {
      const el = $block && $block[0] ? $block[0] : null;
      initOurTeam(el || document);
    });
  }
});

